import type { ChangeFilter, FreeTextSearch, RunDataViewRequest } from '@/api/contracts/dataModel';
import type { QueryFilterItem, QueryOrderByItem } from '@/api/contracts/queryResult';

export interface BuildRunDataViewRequestInput {
  page?: number;
  pageSize?: number;
  filters: QueryFilterItem[];
  orderBy: QueryOrderByItem[];
  changes?: ChangeFilter | null;
  freeText?: FreeTextSearch | null;
}

export function buildRunDataViewRequest (input: BuildRunDataViewRequestInput): RunDataViewRequest {
  return {
    page: input.page ?? 1,
    pageSize: input.pageSize ?? 200,
    additionalFilters: input.filters.map((f) => ({
      tableAliasOrName: '',
      columnName: f.columnName,
      operator: f.operator,
      value: f.value != null ? String(f.value) : null
    })),
    orderByOverride: input.orderBy.map((o) => ({
      tableAliasOrName: '',
      columnName: o.columnName,
      ascending: o.direction === 'ASC'
    })),
    changes: input.changes ?? null,
    freeText: input.freeText ?? null
  };
}
